import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiquidRingCompressor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 90,
	height: 90,
	viewBox: "0 0 90.0 90.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 45,
			cy: 45,
			rx: 45,
			ry: 45,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 45.0 5.0 A 30.0 30.0 0.0 0 1 45.0 45.0 A 30.0 30.0 0.0 0 0 45.0 85.0 M 73.3 16.7 A 30.0 30.0 0.0 0 1 45.0 45.0 A 30.0 30.0 0.0 0 0 16.7 73.3 M 85.0 45.0 A 30.0 30.0 0.0 0 1 45.0 45.0 A 30.0 30.0 0.0 0 0 5.0 45.0 M 73.3 73.3 A 30.0 30.0 0.0 0 1 45.0 45.0 A 30.0 30.0 0.0 0 0 16.5 16.5",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 45,
			cy: 45,
			rx: 3,
			ry: 3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgLiquidRingCompressor;
